import { render, staticRenderFns } from "./export_tch_intership_leave_img.vue?vue&type=template&id=04517850&"
import script from "./export_tch_intership_leave_img.vue?vue&type=script&lang=js&"
export * from "./export_tch_intership_leave_img.vue?vue&type=script&lang=js&"
import style0 from "./export_tch_intership_leave_img.vue?vue&type=style&index=0&id=04517850&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports